import { render, staticRenderFns } from "./ChangeDish.vue?vue&type=template&id=0fbb5c3d&"
import script from "./ChangeDish.vue?vue&type=script&lang=ts&"
export * from "./ChangeDish.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports